import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import u from "./iconfont.es5471.js";
const p = {
  display: "block"
}, f = ({ size: t = 16, useVw: l, useRem: n, color: c, withColor: o, removeClassName: e, disableSSR: d, style: r, ...m }) => {
  const x = r ? { ...p, ...r } : p;
  return /* @__PURE__ */ a.createElement(u, { disableSSR: d }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-startupxinbiwakuang2", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (n ? "rem" : "px"), height: l ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (n ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: x, fill: "none", ...m }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "32px-startupæ°å¸æç¿2"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        clipRule: "evenodd",
        fillRule: "evenodd",
        fill: o ? i(c, 0, "#262933") : "#262933",
        datafollowfill: o ? i(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M12.005 10.482a1.73 1.73 0 0 1-.218-.954A82.595 82.595 0 0 0 4.66 6.405a.95.95 0 0 1-.045-1.755c.604-.269 4.975-2.12 10.16-.84a1.723 1.723 0 0 1 2.264-.544l3.907 2.167c.789.437 1.1 1.4.739 2.208 3.831 3.72 4.577 8.406 4.67 9.06a.95.95 0 0 1-1.513.892 82.6 82.6 0 0 0-6.423-4.388 1.73 1.73 0 0 1-.927.32l-6.842 12.34a3.138 3.138 0 0 1-5.487-3.042l6.842-12.34Zm4.062-5.1.205-.368 3.599 1.994-.205.368a.95.95 0 0 0 .205 1.176c2.185 1.915 3.353 4.23 3.966 5.956a84.506 84.506 0 0 0-5.139-3.358.95.95 0 0 0-1.324.36l-.03.053-3.597-1.995.033-.058a.95.95 0 0 0-.4-1.309 84.518 84.518 0 0 0-5.57-2.58c1.788-.394 4.37-.63 7.152.21a.95.95 0 0 0 1.105-.448Zm-2.524 6.245 2.163 1.2L8.99 24.944a1.238 1.238 0 0 1-2.164-1.2l6.718-12.117Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M25.519 18.909a.9.9 0 0 1 .538 1.153l-.11.3.587.213a2.423 2.423 0 0 1 .419 4.355 2.423 2.423 0 0 1-3.122 3.062l-.586-.214-.109.3a.9.9 0 1 1-1.691-.616l.109-.3-1.095-.398a1.273 1.273 0 0 1-.76-1.631l1.222-3.359.003.001.607-1.666c.24-.661.97-1.002 1.631-.761l1.094.398.11-.3a.9.9 0 0 1 1.153-.538Zm-3.522 5.172-.427 1.172 2.877 1.047a.624.624 0 0 0 .43-1.17l-2.88-1.049Zm4.294-1.016a.623.623 0 0 1-.796.374l-.006-.002-2.874-1.046.427-1.172 2.876 1.047c.324.118.49.476.373.8Z"
        }
      )
    )
  )));
}, k = f;
export {
  k as default
};
